
import Header from '@/components/General/Header.vue';
import { MUTATIONS } from '@/constants/mutationNames';
import { Component, Vue } from 'vue-property-decorator';
import { RouteConfig } from 'vue-router';
import { GETTERS } from '@/constants/getterNames';
import { FLOW_WORKSHOP } from '@/router';

@Component({
  components: {
    Header,
  },
})
export default class WorkshopView extends Vue {
  public routes: RouteConfig[] = FLOW_WORKSHOP;

  get error() {
    return this.$store.getters[GETTERS.GET_ERROR];
  }

  public created() {
    this.$store.commit(MUTATIONS.RESET_TICKETS);
  }

  public dismissError() {
    this.$store.commit(MUTATIONS.SET_ERROR, {});
  }
}
